<template>
  <NewShopWeb />
</template>
<script>
import NewShopWeb from "@/components/NewShopWeb";
export default {
  components: {
    NewShopWeb
  }
}
</script>